export const clientMsgs = {
	addClientSuccess: 'Client has been created successfully.',
	updateClientSuccess: 'Client has been updated successfully.',
	deleteClientSuccess: 'Client has been deleted successfully.',
	scopesLinkToClientSuccess: 'Linked scopes to client successfully.',
	scopesLinkToClientFailed: 'Linking scopes to client failed.',
	unexpectedError: 'Something went wrong, please try again!',
	authFailed: 'Authorization falied, please try again!',
	getScopesToClientFailed: 'No Scopes are linked to this Client.'
};

export const ScopeMsgs = {
	addScopeSuccess: 'Scope has been created successfully.',
	updateScopeSuccess: 'Scope has been updated successfully.',
	deleteScopeSuccess: 'Scope has been deleted successfully.',
	clientsLinkToScopeSuccess: 'Linked Scope to selected clients successfully.',
	clientsLinkToScopeFailed: 'Linking Scope to selected clients failed.',
	getClientsToScopeFailed: 'No Clients are linked to this Scope.'
};

export const dashboardRoute = '/dashboard';

export const paginationSizeOptions = [25, 50, 75, 100];
